import React from "react";
import classNames from "classnames";
import Button from "../Button";
import Icon from "../Icon";

const Document = ({
  active,
  headline,
  strapline,
  itemName,
  itemTypeWalkthrough,
  image,
  onDownload,
  icon,
  small,
  onView,
  onDelete,
  check,
  onClick,
  edit,
  onEdit,
  adaptiveSize=false
}) => {
  return (
    <div
      className={classNames("documents__item", {
        "documents__item--active": active,
        "documents__item--small": small,
        "documents__item--fixed_document_width": !adaptiveSize
      })}
      onClick={() => (onClick ? null : onDownload ? onDownload() : null)}
    >
      <div className="documents__delete">
        {image ? (
          <Button
            style={{ marginRight: '.25em' }}
            color="semantic"
            label={<Icon glyph="download" weight="light" />}
            onClick={() => (onDownload && image !== null ? onDownload(image) : null)}
          />
        ) : null}
        {onView ? (
          <Button
            style={{ marginRight: '.25em' }}
            color="semantic"
            label={<Icon glyph="eye" weight="light" />}
            onClick={() => onView()}
          />
        ) : null}
        {edit ? (
          <Button
            style={{ marginRight: '.25em' }}
            color="semantic"
            label={<Icon glyph="pencil" weight="light" />}
            onClick={() => onEdit()}
          />
        ) : null}
        {onDelete ? (
          <Button
            color="semantic"
            label={<Icon glyph="trash" weight="light" />}
            onClick={() => onDelete()}
          />
        ) : null}
      </div>

      <div>
        <div
          className={classNames("documents__icon", {
            "documents__icon--delete": onDelete ? true : false,
          })}
          onClick={() => (onClick ? onClick() : null)}
        >
          {icon ? icon : <Icon weight="light" glyph="file-contract" />}
        </div>

        {headline && (
          <div
            className="documents__details"
            onClick={() => (onClick ? onClick() : null)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="documents__headline" title={headline}>
                {headline}
              </div>
              {check === true ? (
                <div className="documents__headline--checkIcon">
                  <Icon weight="regular" glyph="check-circle" />
                </div>
              ) : check === false ? (
                <div className="documents__headline--infoIcon">
                  <Icon weight="regular" glyph="info-circle" />
                </div>
              ) : null}
            </div>
            <div className="documents__strapline" title={strapline}>
              {strapline}
            </div>
            <div className="documents__strapline" title={itemName}>
              {itemName}
            </div>
            {itemTypeWalkthrough ? (
              <div className="documents__itemType" title={itemTypeWalkthrough}>
                {itemTypeWalkthrough}
              </div>
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Document;
